export var ValidationMode;

(function (ValidationMode) {
  ValidationMode["Aggressive"] = "aggressive";
  ValidationMode["Lazy"] = "lazy";
  ValidationMode["Passive"] = "passive";
  ValidationMode["Eager"] = "eager";
})(ValidationMode || (ValidationMode = {}));